const slider_0 = document.querySelectorAll('.front_slider');
for (let i = 0; i < slider_0.length; i++) {
  const slides = slider_0[i].querySelectorAll('.swiper-slide');
  if (slides.length <= 1) {
    // スライドが1枚以下なら初期化しない
    continue;
  }

  const front_slider = new Swiper(slider_0[i], {
    loop: true,
    slidesPerView: 'auto',
    slidesPerGroup: 1,
    loopAdditionalSlides: 1,
    freeMode: false,
    centeredSlides: false,
    speed: 600,
    watchOverflow: true,
    autoplay: {
      delay: 4000,
    },
    breakpoints: {
      640: {
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        freeMode: false,
        centeredSlides: false,
      }
    },
  });
}

const slider_0a = document.querySelectorAll('.front_fade');

for (let i = 0; i < slider_0a.length; i++) {
  const slides = slider_0a[i].querySelectorAll('.swiper-slide');
  if (slides.length <= 1) {
    // スライドが1枚以下なら初期化しない
    continue;
  }

  const front_fade = new Swiper(slider_0a[i], {
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    loop: true,
    slidesPerView: 'auto',
    slidesPerGroup: 1,
    //loopAdditionalSlides: 1, //fadeでは絶対に切る事
    freeMode: false,
    allowTouchMove: false,
    preventInteractionOnTransition: true,
    speed: 2000,
    autoplay: {
      delay: 7000,
      disableOnInteraction: false,
      waitForTransition: true,
    },
    watchOverflow: true,
    breakpoints: { //fadeでは必ず必要、エラーの原因に
      0: {
        slidesPerView: 'auto',
      }
    }
  });
}

const slider_1 = document.querySelectorAll('.large_slider');

for (let i = 0; i < slider_1.length; i++) {
  const el = slider_1[i];
  let options = {
    loop: true,
    slidesPerView: 'auto',
    slidesPerGroup: 1,
    loopAdditionalSlides: 1,
    freeMode: false,
    centeredSlides: false,
    speed: 600,
    watchOverflow: true,
    navigation: {
      nextEl: el.querySelector('.swiper-button-next'),
      prevEl: el.querySelector('.swiper-button-prev'),
    },
    pagination: {
      el: el.querySelector('.swiper-pagination'),
      clickable: true,
      type: 'bullets',
    },
  };

  // --- slider-wrap 内の場合は設定を差し替える ---
  if (el.closest('.slider-wrap')) {
    options.navigation.nextEl = el.closest('.slider-wrap').querySelector('.swiper-button-next');
    options.navigation.prevEl = el.closest('.slider-wrap').querySelector('.swiper-button-prev');
    options.pagination.el = el.closest('.slider-wrap').querySelector('.swiper-pagination');
    // 必要であれば他のオプションも差し替え可能
  }

  const large_slider = new Swiper(el, options);
}

const slider_2 = document.querySelectorAll('.middle_slider');
for (let i = 0; i < slider_2.length; i++) {

  const middle_slider = new Swiper(slider_2[i], {
    loop: true,
    slidesPerView: 'auto',
    slidesPerGroup: 1,
    loopAdditionalSlides: 1,
    freeMode: false,
    centeredSlides: false,
    speed: 600,
    watchOverflow: true,
    navigation: {
      nextEl: slider_2[i].querySelector('.swiper-button-next'),
      prevEl: slider_2[i].querySelector('.swiper-button-prev'),
    },
    pagination: {
      el: slider_2[i].querySelector('.swiper-pagination'),
      clickable: true,
      type: 'bullets',
    },

  });
}

/* other_slider */
const myDelay = 7000;

// `.other_slider-wrap` が存在するか確認
const slider_3_wrap = document.querySelectorAll('.other_slider-wrap');
const slider_3 = document.querySelectorAll('.other_slider');

if (slider_3.length > 0) { // other_slider がある場合のみ処理を実行
  // スライド数の取得
  const slideLength = document.querySelectorAll('.other_slider-wrap .swiper-slide').length;
  const total = ('00' + slideLength).slice(-2);

  // スライド番号の要素取得（要素が存在しない場合は処理しない）
  const fractionNum = document.querySelector('.other_slider-wrap .fraction .num');
  const fractionTotal = document.querySelector('.other_slider-wrap .fraction .total');

  if (fractionTotal) {
    fractionTotal.textContent = total;
  }

  // スライド番号の更新
  const updateFraction = (index) => {
    let current = ('00' + (index + 1)).slice(-2);
    if (fractionNum) {
      fractionNum.classList.add('anm-started');
      setTimeout(() => {
        fractionNum.textContent = current;
        fractionNum.classList.remove('anm-started');
      }, 400);
    }
  }

  // スライド外コンテンツのアニメーション開始
  const startAnimation = (index) => {
    let activeSlide = document.querySelectorAll('.other_slider-wrap .content')[index];
    if (activeSlide) {
      activeSlide.classList.remove('anm-finished');
      activeSlide.classList.add('anm-started');
    }
  }

  // スライド外コンテンツのアニメーション終了
  const finishAnimation = () => {
    let activeSlide = document.querySelector('.other_slider-wrap .content.anm-started');
    if (activeSlide) {
      activeSlide.classList.remove('anm-started');
      activeSlide.classList.add('anm-finished');
    }
  }

  // スライダーの設定
  for (let i = 0; i < slider_3.length; i++) {
    let prev = slider_3_wrap[i].querySelector('.swiper-button-prev');
    let next = slider_3_wrap[i].querySelector('.swiper-button-next');
    let pagination = slider_3_wrap[i].querySelector('.swiper-pagination');

    const other_slider = new Swiper(slider_3[i], {
      loop: true,
      slidesPerView: 'auto',
      slidesPerGroup: 1,
      loopAdditionalSlides: 1,
      freeMode: false,
      centeredSlides: false,
      speed: 600,
      navigation: {
        nextEl: next,
        prevEl: prev,
      },
      pagination: {
        el: pagination,
        clickable: true,
        type: 'bullets',
      },
      breakpoints: {
        640: {
          slidesPerView: 'auto',
          slidesPerGroup: 1,
          freeMode: false,
          centeredSlides: false,
        }
      },
      on: {
        init: (swiper) => {
          finishAnimation();
          startAnimation(swiper.realIndex);
          updateFraction(swiper.realIndex);
        },
        slideChange: (swiper) => {
          updateFraction(swiper.realIndex);
        },
        slideChangeTransitionStart: (swiper) => {
          finishAnimation();
          startAnimation(swiper.realIndex);
        },
      }
    });
  }
}

/* auto_slider */
const slider_5 = document.querySelectorAll('[class*="auto_slider"]');
for (let i = 0; i < slider_5.length; i++) {
  const auto_slider = new Swiper(slider_5[i], {
    slidesPerView: "auto",
    loop: true,
    loopAdditionalSlides: 1,
    speed: 10000,
    allowTouchMove: false,
    centeredSlides: false,
    preventInteractionOnTransition: true,
    autoplay: {
      delay: 0,
      disableOnInteraction: false
    },
    breakpoints: {
      640: {
        // 小さい画面サイズの設定が必要な場合にここに追加
      }
    }
  });
}


/*  */

const slider_6 = document.querySelectorAll('.fade_slider');
for (let i = 0; i < slider_6.length; i++) {

  const fade_slider = new Swiper(slider_6[i], {
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    loop: true,
    slidesPerGroup: 1,
    freeMode: false,
    //allowTouchMove: false,
    centeredSlides: false,
    preventInteractionOnTransition: true,
    speed: 600,
    watchOverflow: true,
    navigation: {
      nextEl: slider_6[i].querySelector('.swiper-button-next'),
      prevEl: slider_6[i].querySelector('.swiper-button-prev'),
    },
    pagination: {
      el: slider_6[i].querySelector('.swiper-pagination'),
      clickable: true,
      type: 'bullets',
    },
    //loopAdditionalSlides: 1, //fadeでは絶対に切る事

    breakpoints: { //fadeでは必ず必要、エラーの原因に
      0: {
        slidesPerView: 'auto',
      }
    }
  });
}


const sliderPairs = document.querySelectorAll('.slider-wrap');

sliderPairs.forEach(pair => {
  const fadeEl = pair.querySelector('.fade_slider');
  const largeEl = pair.querySelector('.large_slider');

  if (!fadeEl || !largeEl) return;

  const fadeSlider = fadeEl.swiper;
  const largeSlider = largeEl.swiper;

  if (fadeSlider && largeSlider) {
    // large → fade の片方向
    largeSlider.on('slideChange', () => {
      // largeSliderのactiveIndexに合わせてfadeSliderを移動
      fadeSlider.slideToLoop(largeSlider.realIndex);
      // fadeSlider.slideTo(largeSlider.activeIndex); でも動くが loop がある場合は slideToLoop の方が安全
    });
  }
});


const slider_7 = document.querySelectorAll('.youtube_slider');
for (let i = 0; i < slider_7.length; i++) {

  const youtube_slider = new Swiper(slider_7[i], {
    loop: true,
    slidesPerView: 'auto',
    slidesPerGroup: 1,
    loopAdditionalSlides: 1,
    freeMode: false,
    centeredSlides: true,
    speed: 600,
    watchOverflow: true,
    autoplay: {
      delay: 4000,
    },
    navigation: {
      nextEl: slider_7[i].querySelector('.swiper-button-next'),
      prevEl: slider_7[i].querySelector('.swiper-button-prev'),
    },
    pagination: {
      el: slider_7[i].querySelector('.swiper-pagination'),
      clickable: true,
      type: 'bullets',
    },

  });
}


const slider_8 = document.querySelectorAll('.min_slider');
for (let i = 0; i < slider_8.length; i++) {

  const min_slider = new Swiper(slider_8[i], {
    loop: true,
    slidesPerView: 'auto',
    slidesPerGroup: 1,
    loopAdditionalSlides: 1,
    freeMode: false,
    centeredSlides: false,
    speed: 600,
    watchOverflow: true,
    navigation: {
      nextEl: slider_8[i].querySelector('.swiper-button-next'),
      prevEl: slider_8[i].querySelector('.swiper-button-prev'),
    },
    pagination: {
      el: slider_8[i].querySelector('.swiper-pagination'),
      clickable: true,
      type: 'bullets',
    },

  });
}



const slider_9 = document.querySelectorAll('.lp_gallery_slider');
for (let i = 0; i < slider_9.length; i++) {

  const lp_gallery_slider = new Swiper(slider_9[i], {
    slidesPerView: 'auto',
    slidesPerGroup: 1,
    loopAdditionalSlides: 1,
    freeMode: false,
    centeredSlides: false,
    speed: 600,
    watchOverflow: true,
    navigation: {
      nextEl: slider_9[i].querySelector('.swiper-button-next'),
      prevEl: slider_9[i].querySelector('.swiper-button-prev'),
    },
    pagination: {
      el: slider_9[i].querySelector('.swiper-pagination'),
      clickable: true,
      type: 'bullets',
    },

  });
}